import { debounce } from 'lodash-es';
import { assignIds } from './assign-ids';

let observer: MutationObserver | null = null;

export const observeAndAssignIds = () => {
  if (
    window.APP_CONFIG.VUE_APP_USE_ID_ASSIGNER === '1'
    && !window.location.hostname.includes('pendo.staging')
    && !observer
  ) {
    const debouncedAssignIds = debounce(assignIds, 200);
    observer = new MutationObserver(() => debouncedAssignIds());
    observer.observe(document.body, {
      characterDataOldValue: true,
      subtree: true,
      childList: true,
      characterData: true,
    });
  }
};
